(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-success.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-success.js');

'use strict';

const {
  getProductName,
  isDaySpecificId,
  getDay
} = svs.numbergames.productMapping;
class PaymentSuccess extends svs.tur.payment.dialogs.PaymentSuccess {
  constructor(_ref) {
    let {
      products,
      recipientName,
      isAfterPayAndAutoPay,
      productName,
      productNumeric,
      accountBalance,
      contactInfo,
      onConfirm
    } = _ref;
    super({});
    this.products = products;
    this.recipientName = recipientName;
    this.isAfterPayAndAutoPay = isAfterPayAndAutoPay;
    this.productName = productName;
    this.productNumeric = productNumeric;
    this.accountBalance = accountBalance;
    this.contactInfo = contactInfo;
    this.onConfirm = onConfirm;
  }
  getTitle() {
    if (this.isAfterPayAndAutoPay) {
      return 'Din insättning och betalning är klar!';
    }
    return 'Ditt andelsspel är reserverat!';
  }
  getMessage() {
    const message = [];
    const fractiongamesReservedUrl = svs.core.urlMapping.get('fractiongamesReserved');
    if (this.isAfterPayAndAutoPay && this.productName && this.productNumeric && this.accountBalance) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Du har reserverat en andel p\xE5 ".concat(getProductName(this.productName)).concat(isDaySpecificId(this.productNumeric) ? " ".concat(getDay(this.productNumeric).toLowerCase()) : '', ". <br /> \n        Du hittar den p\xE5 Andelsspelsidan under <a href=").concat(fractiongamesReservedUrl, ">Reserverade spel</a>."),
        align: svs.components.dialog.message.align.CENTER
      });
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "N\xE4r alla andelar \xE4r s\xE5lda flyttas den till Mina spel.",
        align: svs.components.dialog.message.align.CENTER
      });
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "Ditt saldo: ".concat(svs.utils.format.Currency(this.accountBalance), " kr"),
        align: svs.components.dialog.message.align.CENTER
      });
      return message;
    }
    message.push({
      type: svs.components.dialog.message.TEXT,
      text: "Du hittar det p\xE5 andelsspelsidan under <a href=".concat(fractiongamesReservedUrl, ">Reserverade spel</a>.<br />\n      Direkt n\xE4r alla andelar i spelet \xE4r s\xE5lda hamnar det i Mina spel."),
      align: svs.components.dialog.message.align.CENTER
    });
    return message;
  }
}
svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentSuccess = PaymentSuccess;

 })(window);